import { AppBar, Box, Toolbar } from '@mui/material';
import { HeaderLogin } from '.';
import { useNavigate } from 'react-router';
import { EPageNames, ETabValue } from '../data/Constants';
import philipsLogo from '../assets/images/png/logo.png';

import type { IHeaderProps } from '../../types';

/**
 * Renders the header which also includes the buttons to hide/show the TabDrawer and InfoPanel
 * @param {IHeaderProps} headerProps the properties for the header component
 * @returns {JSX.Element} the header component
 */
export const Header = (headerProps: IHeaderProps) => {
  const navigate = useNavigate();
  const navigateToHome = () => {
    if (!EPageNames.UserManagement.includes(location.pathname)) {
      headerProps.setTabValue(ETabValue.AdministrationTab); // setting tabValue to administration
      navigate(EPageNames.UserManagement, { replace: true });
    }
  };

  return (
    <AppBar className="headerStyle root" position="static">
      <Toolbar className="toolbar">
        <Box className="toolbarSection">
          <button onClick={navigateToHome} className="btn-plain" aria-label="Go to home">
            <img className="zoom80 headerLogo" src={philipsLogo} alt="Philips logo" />
          </button>
        </Box>
        <Box className="toolbarSection">
          <HeaderLogin />
        </Box>
      </Toolbar>
    </AppBar>
  );
};
